export const BEGIN_AJAX_CALL = "BEGIN_AJAX_CALL";
export const END_AJAX_CALL = "END_AJAX_CALL";
export const AJAX_CALL_ERROR = "AJAX_CALL_ERROR";
export const AJAX_CALL_CLEAR = "AJAX_CALL_CLEAR";

export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const SET_SUCCESS_MESSAGE = "SET_SUCCESS_MESSAGE";
export const SET_APPLY_BLOCKED = "SET_APPLY_BLOCKED";
export const CLEAR_APPLY_BLOCKED = "CLEAR_APPLY_BLOCKED";
export const SET_LOADING_STATE = "SET_LOADING_STATE";

export const SET_USER_INFO = "SET_USER_INFO";

// MASTER DATA

export const SET_INDUSTRIES = "SET_INDUSTRIES";
export const SET_LANGUAGES = "SET_LANGUAGES";
export const SET_DEGREES = "SET_DEGREES";
export const SET_COURSE_NAMES = "SET_COURSES";
export const SET_COURSE_SPECIALIZATION = "SET_COURSE_SPECIALIZATION";
export const SET_BOARDS = "SET_BOARDS";
export const SET_HOBBIES = "SET_HOBBIES";
export const SET_DEPARTMENTS = "SET_DEPARTMENTS";
export const SET_DESIGNATIONS = "SET_DESIGNATIONS";
export const SET_TOOLS_KNOWN = "SET_TOOLS_KNOWN";
export const SET_SKILLS = "SET_SKILLS";
export const SET_UNIVERSITY = "SET_UNIVERSITY";
export const SET_CITIES = "SET_CITIES";
export const SET_FUNCTIONS = "SET_FUNCTIONS";
export const SET_JOB_ROLES = "SET_JOB_ROLES";

// Profile

export const SET_USER_DETAILS = "SET_PROFILE_DETAILS";
export const SET_USER_PREFERENCE = "SET_USER_PREFERENCE";
export const SET_USER_EDUCATION = "SET_USER_EDUCATION";
export const SET_USER_EXPERIENCE = "SET_USER_EXPERIENCE";
export const SET_USER_CERTIFICATE = "SET_USER_CERTIFICATE";

export const SET_QUESTIONS = "SET_QUESTIONS";
export const SET_PERSONALITY = "SET_PERSONALITY";
export const SET_TOPIC_SCORE = "SET_TOPIC_SCORE";
export const SET_SCORE_BAND = "SET_SCORE_BAND";
export const SET_PERKS = "SET_PERKS";

// JOBS

export const SET_SKIPPED_JOBS = "SET_SKIPPED_JOBS";
export const SET_SHORTLISTED_JOBS = "SET_SHORTLISTED_JOBS";
export const SET_LISTING_JOBS = "SET_LISTING_JOBS";
export const SET_APPLIED_JOBS = "SET_APPLIED_JOBS";
export const SET_JOB_DETAILS = "SET_JOB_DETAILS";

export const UPDATE_PROMPT = "UPDATE_PROMPT";

export const SET_PROMPTS = "SET_PROMPTS";

export const SET_USER_VIDEOS = "SET_USER_VIDEOS";
export const SET_VIDEO_QUESTIONS = "SET_VIDEO_QUESTIONS";

export const SET_B2B_ACTIVE_TAB = "SET_B2B_ACTIVE_TAB";
export const SET_USER_COMPANY_DETAILS = "SET_USER_COMPANY_DETAILS";
export const CLEAR_USER_COMPANY_DETAILS = "CLEAR_USER_COMPANY_DETAILS";
export const SET_CLIENT_JOB_DETAILS = "SET_CLIENT_JOB_DETAILS";
export const SET_B2B_JOB_DETAILS = "SET_B2B_JOB_DETAILS";
export const SET_B2B_JOB_APPLICANTS = "SET_B2B_JOB_APPLICANTS";
export const SET_APPLICANT_DETAILS = "SET_APPLICANT_DETAILS";
export const SET_APPLICANT_DETAILS_LOADING = "SET_APPLICANT_DETAILS_LOADING";
export const CLEAR_APPLICANT_DETAILS = "CLEAR_APPLICANT_DETAILS";
export const UPDATE_BEST_FIT_STATUS = "UPDATE_BEST_FIT_STATUS";
export const CREATE_COMMENT = "CREATE_COMMENT";
export const EDIT_COMMENT = "EDIT_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const SET_COMMENTS = "SET_COMMENTS";
export const CREATE_SHARE_LINK = "CREATE_SHARE_LINK";
export const SET_APPLICANT_REPORT = "SET_APPLICANT_REPORT";
export const SET_APPLICANT_PERSONALITY = "SET_APPLICANT_PERSONALITY";
export const SET_APPLICANT_TOPIC_SCORE = "SET_APPLICANT_TOPIC_SCORE";
export const SET_APPLICANT_SCORE_BAND = "SET_APPLICANT_SCORE_BAND";
export const VALIDATE_SHARE_LINK = "VALIDATE_SHARE_LINK";
export const VALIDATE_SHARE_PASSWORD = "VALIDATE_SHARE_PASSWORD";

export const SET_FUNCTION_PERSONALITY = "SET_FUNCTION_PERSONALITY";


// companyList 
export const SET_COMPANY_LIST = "SET_COMPANY_LIST";
export const SET_COMPANY_LIST_PAGE = "SET_COMPANY_LIST_PAGE";
export const SET_COMPANY_LIST_TOTAL_COUNT = "SET_COMPANY_LIST_TOTAL_COUNT";
export const SET_COMPANY_LIST_ROWS_PER_PAGE = "SET_COMPANY_LIST_ROWS_PER_PAGE";
export const SET_COMPANY_LIST_LOADING = "SET_COMPANY_LIST_LOADING";
export const SET_HIRING_COMPANIES = "SET_HIRING_COMPANIES";


// userList
export const SET_USER_LIST = "SET_USER_LIST";
export const SET_USER_LIST_PAGE = "SET_USER_LIST_PAGE";
export const SET_USER_LIST_TOTAL_COUNT = "SET_USER_LIST_TOTAL_COUNT";
export const SET_USER_LIST_ROWS_PER_PAGE = "SET_USER_LIST_ROWS_PER_PAGE";
export const SET_USER_LIST_LOADING = "SET_USER_LIST_LOADING";
export const SET_COMPANY_USER_LIST = "SET_COMPANY_USER_LIST";

// Organization Account Settlements
export const SET_ORG_ACCOUNT_SETTLEMENTS = "SET_ORG_ACCOUNT_SETTLEMENTS";

export const SET_JOB_SEARCH_FILTERS = "SET_JOB_SEARCH_FILTERS";
export const CLEAR_JOB_SEARCH_FILTERS = "CLEAR_JOB_SEARCH_FILTERS";